/* One independent FAQ disclosure controller. Answers are already in the HTML. */
if (!customElements.get('dio-faq')) {
  customElements.define('dio-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.onFAQClick) return;
      this.onFAQClick = event => {
        const button = event.target.closest('[data-dio-faq-question]');
        if (!button || button.closest('dio-faq') !== this) return;
        const answer = this.querySelector('[id="' + button.getAttribute('aria-controls') + '"]');
        if (!answer) return;
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        answer.hidden = !open;
      };
      this.addEventListener('click', this.onFAQClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onFAQClick);
      this.onFAQClick = null;
    }
  });
}
